// components/ui/PageHeader.tsx
import { useNavigate } from "react-router-dom"
import { ArrowLeft } from "lucide-react"
import { NavLink as Link } from "./NavLink"

interface PageHeaderProps {
    title?: string
    breadcrumb?: {
        label: string
        href: string
    }[]
    showBackButton?: boolean
    backUrl?: string
    className?: string
}

export default function PageHeader({ 
    title, 
    breadcrumb = [], 
    showBackButton = true,
    backUrl,
    className = ""
}: PageHeaderProps) {
    const navigate = useNavigate()

    const handleBack = () => {
        if (backUrl) {
            navigate(backUrl)
        } else {
            navigate(-1)
        }
    }

    return (
        <div className={`border-b border-gray-100 bg-white/80 backdrop-blur-md sticky top-0 z-20 ${className}`}>
            <div className="px-4 md:container md:mx-auto md:px-4 py-3">
                <div className="flex items-center justify-between gap-3">
                    {/* Bouton retour */}
                    {showBackButton && (
                        <button
                            onClick={handleBack}
                            className="group flex items-center justify-center gap-2 text-gray-500 hover:text-orange-600 transition-all duration-300 min-w-[44px] min-h-[44px]"
                        >
                            <div className="w-8 h-8 md:w-9 md:h-9 rounded-full bg-gray-100 group-hover:bg-orange-100 flex items-center justify-center transition-all duration-300">
                                <ArrowLeft className="w-4 h-4 md:w-5 md:h-5 group-hover:-translate-x-0.5 transition-transform" />
                            </div>
                            <span className="text-sm font-medium hidden sm:inline">Retour</span>
                        </button>
                    )}

                    {/* Breadcrumb */}
                    <div className="flex items-center gap-1 md:gap-2 text-xs text-gray-400 overflow-x-auto scrollbar-hide flex-1 justify-center">
                        <Link to="/" className="hover:text-orange-600 transition whitespace-nowrap">
                            Accueil
                        </Link>
                        
                        {breadcrumb.map((item, index) => (
                            <div key={index} className="flex items-center gap-1 md:gap-2">
                                <span className="text-gray-300">/</span>
                                {index === breadcrumb.length - 1 ? (
                                    <span className="text-gray-600 truncate whitespace-nowrap max-w-[120px] md:max-w-none">
                                        {item.label}
                                    </span>
                                ) : (
                                    <Link 
                                        to={item.href} 
                                        className="hover:text-orange-600 transition whitespace-nowrap"
                                    >
                                        {item.label}
                                    </Link>
                                )}
                            </div>
                        ))}
                        
                        {title && !breadcrumb.length && (
                            <>
                                <span className="text-gray-300">/</span>
                                <span className="text-gray-600 truncate whitespace-nowrap max-w-[120px] md:max-w-none">
                                    {title}
                                </span>
                            </>
                        )}
                    </div>

                    {/* Espace vide pour équilibre */}
                    <div className="w-8 md:w-20" />
                </div>
            </div>
        </div>
    )
}